/**
 * Assign tabindex if it is not already set.
 */
export function assignTabindex(target, value) {
    var tabindex = target.getAttribute('tabindex');
    if (tabindex === null || tabindex === '') {
        target === null || target === void 0 ? void 0 : target.setAttribute('tabindex', value);
    }
}
